import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class PersonalLineOfCreditSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <rect className={css(styles.actionAccent)} x="15.538" y="15.723" width="35.281" height="22.696" rx="1.974" />
          <rect className={css(styles.action)} x="15.551" y="19.959" width="35.28" height="4.295" />
          <path
            className={css(styles.grey)}
            d="M29.437,31.433H19.008a.771.771,0,1,1,0-1.541H29.437a.771.771,0,1,1,0,1.541Z"
          />
          <path
            className={css(styles.grey)}
            d="M26.54,34.91H19.008a.771.771,0,0,1,0-1.542H26.54a.771.771,0,1,1,0,1.542Z"
          />
          <polygon
            className={css(styles.action)}
            points="67.665 27.802 65.207 27.802 32.837 27.802 32.837 84.277 77.725 84.277 77.725 41.807 77.725 37.863 67.665 27.802"
          />
          <rect className={css(styles.actionAccent)} x="39.443" y="33.967" width="17.508" height="4.686" rx="0.803" />
          <polygon className={css(styles.grey)} points="67.681 37.793 77.656 37.793 67.681 27.818 67.681 37.793" />
          <path className={css(styles.white)} d="M70,54.467H40.237a.771.771,0,0,1,0-1.541H70a.771.771,0,1,1,0,1.541Z" />
          <path className={css(styles.white)} d="M70,46.761H40.237a.771.771,0,0,1,0-1.541H70a.771.771,0,1,1,0,1.541Z" />
          <path
            className={css(styles.white)}
            d="M45.389,69.979H40.237a.771.771,0,0,1,0-1.541h5.152a.771.771,0,1,1,0,1.541Z"
          />
          <path className={css(styles.white)} d="M70,62.3H40.237a.771.771,0,0,1,0-1.541H70A.771.771,0,1,1,70,62.3Z" />
          <path
            className={css(styles.white)}
            d="M48.82,69.652A5.959,5.959,0,0,1,50.2,68.577c.314-.141.7-.206.762.183a3.7,3.7,0,0,1-.076.533,1.043,1.043,0,0,0,.938,1.118,2.962,2.962,0,0,0,2.057-.689,18.5,18.5,0,0,1,2.281-1.475,8.464,8.464,0,0,1,2.916-1.036c1.4-.114.81,1.047,1.009,1.871.418,1.738,2.387,1.146,3.4.379.39-.3.006-.966-.389-.666-.839.636-2.37,1.171-2.275-.443.038-.635.033-1.287-.566-1.67a2.529,2.529,0,0,0-2.024-.081,13.457,13.457,0,0,0-2.682,1.1c-.8.427-1.483.984-2.233,1.481-.311.206-1.091.7-1.477.457-.343-.219-.074-.816-.124-1.142-.314-2.047-2.768.005-3.442.614-.369.334.177.877.544.545Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="73.001"
            y="45.208"
            width="4.819"
            height="23.682"
            transform="translate(90.819 150.345) rotate(-136.486)"
          />
          <polygon className={css(styles.white)} points="65.511 63.977 69.005 67.295 64.397 68.667 65.511 63.977" />
          <polygon
            className={css(styles.actionAccent)}
            points="64.904 66.506 66.512 68.032 64.392 68.663 64.904 66.506"
          />
          <path
            className={css(styles.grey)}
            d="M82.207,45.825h4.819a0,0,0,0,1,0,0v.751a2.306,2.306,0,0,1-2.306,2.306h-.207a2.306,2.306,0,0,1-2.306-2.306v-.751a0,0,0,0,1,0,0Z"
            transform="translate(113.376 139.956) rotate(-136.486)"
          />
        </g>
      </svg>
    );
  }
}
